import { ReactNode, useEffect } from 'react';
import LiffHeader from '../LiffHeader';
import { StyledLiffContent } from './Styled';

const LiffLayout = ({ page }: { page: ReactNode }) => {
  useEffect(() => {
    document.body.classList.add('scroll-lock', 'fullscreen');

    return () => {
      document.body.classList.remove('scroll-lock', 'fullscreen');
    };
  }, []);

  return (
    <>
      <LiffHeader />
      <StyledLiffContent>{page}</StyledLiffContent>
    </>
  );
};

export default LiffLayout;
